import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Control from '@/helpers/control'
import getStyle from '@/helpers/getStyle'

import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'

@Component({
	components: {
		TypeableDatePortal,
	},
})
export default class TableHead extends Vue {
	@Prop() fields

	getStyle = getStyle

	emitFilters() {
		const data = {}
		this.fields.forEach((field) => {
			if (field.filter) {
				const name = field?.filter?.name || field?.fieldName
				if (
					field.filter.model === null ||
					field.filter.model === undefined
				) {
					field.filter.model = ''
				}

				if (field.unformat) {
					data[name] = field.unformat(field.filter.model)
				} else {
					data[name] = field.filter.model
				}

				if (data[name] === 'true') {
					data[name] = true
				}

				if (data[name] === 'false') {
					data[name] = false
				}
			}
		})

		this.$emit('onFilter', data)
	}

	onFilterDateChange(date, field, type?) {
		if (type) {
			field.filter.model[type] = date
		} else {
			field.filter.model = date
		}

		this.emitFilters()
	}

	control = new Control()

	onInput() {
		const debouncedChange = this.control.debounce(this.emitFilters, 400)
		debouncedChange()
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			const name = removeAccents(item?.name?.toLowerCase())

			return searchArray.every((string) => {
				return name.includes(removeAccents(string.toLowerCase()))
			})
		})

		return result
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
